export class Result<T, E extends Error> {
  _value: T | null = null;
  _err: E | null = null;

  constructor(value: T | null, err: E | null) {
    if (!value && !err) {
      throw new Error('Result must have a value or an error');
    }
    if (value && err) {
      throw new Error('Result cannot have both a value and and error');
    }

    if (err !== null) {
      this._err = err as E;
    } else {
      this._value = value;
    }
  }

  unwrap(): T {
    if (this.isOk()) {
      return this._value as T;
    }

    if (this.isErr()) {
      throw this._err as E;
    }

    throw new Error('Unknown error');
  }

  expect(msg: string): T {
    if (this.isOk()) {
      return this._value as T;
    }

    if (this.isErr()) {
      const err = this._err as E;
      throw (err.message = msg + ':\n ' + err.message);
    }

    throw new Error(msg);
  }

  isOk(): this is Result<T, never> {
    return this._value !== null;
  }

  isErr(): this is Result<never, E> {
    return this._err !== null;
  }

  getErr(): this extends Result<never, E> ? E : E | null {
    return this._err as E;
  }
}
